import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import Img from 'gatsby-image';

export default function PageTemplate({ data }) {
  const { mdx } = data
  const { frontmatter } = mdx
  const { title, featuredImage, briefing, about, client, targetAudience, video, category } = frontmatter
  return (
    <Layout>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={`Detalhes sobre o projeto ${title}`} />
      </Helmet>

      <section className="project">
        <div className="inner">
          <header className="major">
            <h1 className="pf">{title}</h1>
          </header>
          <div className="row">
            {
              briefing && about && (
                <div className="col-md">
                  <h2>Briefing</h2>
                  <p>{briefing}</p>
                  <h2>Sobre o texto</h2>
                  <p>{about}</p>
                </div>
              )
            }
            {
              briefing && !about && (
                <div className="col-md">
                  <h2>Briefing</h2>
                  <p>{briefing}</p>
                </div>
              )
            }
            {
              !briefing && about && (
                <div className="col-md">
                  <h2>Sobre o Texto</h2>
                  <p>{about}</p>
                </div>
              )
            }

            {
              client && (
                <div className="col-md">
                  <div className="box">
                    <h3><i className="icon fa-user"></i> Cliente</h3>
                    <p>{client}</p>
                    <h3><i className="icon fa-bullseye"></i> Público-alvo</h3>
                    <p>{targetAudience}</p>
                  </div>
                </div>
              )
            }


          </div>
          {
            title !== "Dia das Mães | Cetaphil e Dermotivin" && title !== "Fibernorm" && title !== "Zoetis" && title !== "Virbac" && title !== "Indigo Ag" && (
              <span className="image main">
                <Img fluid={featuredImage.childImageSharp.fluid} />
              </span>
            )
          }

          {/* Se carrosel azul, fecha div aqui */}

          <MDXProvider>
            <MDXRenderer>{mdx.body}</MDXRenderer>
          </MDXProvider>

          {
            !!video && (
              <>
                {
                  <div className="box">
                    <p>Para ver o vídeo, clique <a target="_blank" rel="noreferrer" href={video}>aqui</a> </p>
                  </div>
                }
              </>

            )
          }

          {/* e abre de volta aqui */}
          {
            title === 'Dia das Mães | Cetaphil e Dermotivin' && (
              <span className="image main">
                <Img fluid={featuredImage.childImageSharp.fluid} />
              </span>
            )
          }
        </div>
      </section>

    </Layout >
  )
}

export const pageQuery = graphql`
query createTpl($id: String) {
  mdx(id: {eq: $id}) {
    id
    body
    frontmatter {
      briefing
      about
      client
      targetAudience
      category
      title
      path
      video
      featuredImage {
        childImageSharp {
          fluid(quality: 90) {
            aspectRatio
            base64
            sizes
            src
            srcSet
          }
        }
      }
    }
  }
}

`